// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"f3a2a647","197":"ea033765","313":"d9d048a9","486":"6fb59e0a","794":"2b8dd1b9","821":"05fa6ac5"}[chunkId] + ".css";
};